import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { motion } from "framer-motion";
import ReCAPTCHA from "react-google-recaptcha"
import { Link } from "react-router-dom";
//components
import validateForm from "../../components/validateForm";
import ResetLocation from "../../helpers/ResetLocation";
import loaderGif from '../../assets/images/loading.webp';
import './contact.css'

const Contact = () => {
  const [formValue, setFormValue] = useState({ fullname: '', email: '', message: "" });
  const [submit, setSubmit] = useState(false);
  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);
  const [captchaError, setCaptchaError] = useState('')
  const validate = validateForm("contact");
  const captchaRef = useRef();
  useEffect(() => {
    document.title = "Kontakt | Casaantonio e piccolo gió";
  }, []);
  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    
    // Validate form fields
    const errors = validate(formValue);
    setFormError(errors);
    setSubmit(true);
  
    if (Object.keys(errors).length > 0) {
      setLoading(false);
      setSubmit(false);
      return;
    }
  
    // reCAPTCHA verification
    let captchaToken = captchaRef.current?.getValue();
    if (!captchaToken) {
      setCaptchaError("reCaptcha is mandatory");
      setLoading(false);
      setSubmit(false);
      return;
    }
  
    const verification = await verifyCaptcha(captchaToken);
    captchaRef.current?.reset();
  
    if (!verification) {
      ResetLocation();
      setLoading(false);
      setSubmit(false);
      setCaptchaError("");
      return;
    }
  
    // Submit to Brevo
    try {
      const response = await fetch("/.netlify/functions/brevoContact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: formValue.email,
          attributes: {
            FIRSTNAME: formValue.fullname,
            MESSAGE: formValue.message,
          },
          listIds: [6],
          updateEnabled: true
        }),
      });
  
      if (response.ok) {
        setSubmit(true);
        ResetLocation();
        setFormValue({ fullname: '', email: '', message: '' });
        setCaptchaError("");
      } else {
        console.error("Brevo API submission failed.");
        setSubmit(false);
      }
    } catch (error) {
      console.error("Submission failed:", error);
      setSubmit(false);
    }
  
    setLoading(false);
  }
  const handleValidation = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  }
  const verifyCaptcha = async (captchaToken) => {
    try {
      const response = await fetch("https://captcha-server-vip2.onrender.com/verify-captcha", {
        method: 'POST',
        body: JSON.stringify({
          captchaToken,
        }),
        headers: {
          'Content-Type': 'application/json',
        }
      });
  
      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error("Could not verify captcha!", error.message);
      return false;
    }
  }
  return (
    <motion.main
      className="contact"
      initial={{ opacity: 0, translateX: -300 }}
      whileInView={{ opacity: 1, translateX: 0 }}
      exit={{ opacity: 0, translateX: -300 }}
      transition={{ duration: 1 }}>
      {loading ?
        <section className="contact-loader">
          <p>Fast geschafft...</p>
          <img alt="Anfrage wird bearbeitet" src={loaderGif} />
        </section>
        :
        submit && Object.keys(formError).length === 0 ?
          <section className="contact__success-msg">
            <p>Wir haben deine Nachricht erhalten und melden uns in Kürze! 🍕</p>
            <section>
              <Link className="active-button-style" to="/menu">Zur Speisekarte</Link>
              <button className="passive-button-style" type="button" onClick={() => { setSubmit(false); }}>Erneut senden</button>
            </section>
          </section>
          :
          <form onSubmit={handleSubmit} className="flex-container flex-column">
            <div className="webflow-style-input">
              <input
                onChange={handleValidation}
                value={formValue.fullname}
                name="fullname"
                className="pop-font"
                type="text"
                placeholder="Vollständiger Name"
              />
            </div>
            <span className="input-validation-error">{formError.fullname}</span>
            <div className="webflow-style-input">
              <input
                onChange={handleValidation}
                value={formValue.email}
                name="email"
                className="pop-font"
                type="text"
                placeholder="E-Mail"
              />
            </div>
            <span className="input-validation-error">{formError.email}</span>
            <div className=" webflow-style-input">
              <textarea
                onChange={handleValidation}
                value={formValue.message}
                name="message"
                className="pop-font"
                placeholder="Nachricht"
              />
            </div>
            <span className="input-validation-error">{formError.message}</span>
            <ReCAPTCHA ref={captchaRef} sitekey={process.env.REACT_APP_CAPTCHA_KEY} theme="dark" />
            <span className="input-validation-error">{captchaError}</span>
            <button type="submit" className="active-button-style" >
              Senden
            </button>
          </form>
      }
      <section className="contact__cover"></section>
        <section className="contact__inner pop-font">
          <h2 className="">Kontaktiere uns</h2>
          <p>
          Wir freuen uns, von dir zu hören! Ob du Fragen hast, Unterstützung brauchst oder einfach nur mit uns in Kontakt treten möchtest – wir sind für dich da. Deine Anfrage ist uns wichtig und wir setzen alles daran, dir mit Klarheit und Hilfe zur Seite zu stehen. Melde dich jederzeit – wir freuen uns auf deine Nachricht!
          </p>
        </section>
    </motion.main>
  );
}


export default Contact;